import { Info } from 'lucide-react';
import {
  IconButton,
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverTrigger,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

/** The info mark beside the automatic-preparation switch: one sentence, on a click, also on a phone. */
export function SupportInfo() {
  return (
    <Popover>
      <PopoverTrigger
        render={
          <IconButton
            variant='quiet'
            size='sm'
            aria-label={m.team_support_info_label()}
            className='text-ink-muted'
          />
        }
      >
        <Info className='size-3.5' aria-hidden='true' />
      </PopoverTrigger>
      <PopoverContent side='bottom' align='end' className='w-80 px-4 py-3.5'>
        <PopoverDescription className='text-ink'>
          {m.team_support_info()}
        </PopoverDescription>
      </PopoverContent>
    </Popover>
  );
}
